import ShopifyFrame from './shopify_frame_babel';
import NewsletterForm from './newsletter_form_babel';

export default [
  ShopifyFrame,
  NewsletterForm,
];



// WEBPACK FOOTER //
// ./scripts/components/index.js